import type { StepConfig } from '../../types/workflow';

const dateTime: StepConfig = {
  // Design
  icon: 'datetime',
  headerTextColor: '#BE2528',
  headerColor: '#ECD9DB',
  title: 'Date & Time',
  text: 'Date & Time',
  category: 'Router',
  desc: 'Allows a branch to be created based on date & time conditions. Use it to set business hours or date range conditions.',
  primaryKey: (parentValues: Record<string, any>) => {
    return `${parentValues.businessHours.condition.replaceAll('_', ' ')}: ${parentValues.branchType.replaceAll('_', ' ')}\nTime Zone: ${parentValues.businessHours.timezone}`;
  },

  // Connector configuration
  connectors: {
    DateTimeWithin: {
      headerTextColor: '#BE2528',
      headerColor: '#ECD9DB',
      title: 'Success',
      category: 'Connector',
    },
    DateTimeNotWithin: {
      headerTextColor: '#BE2528',
      headerColor: '#ECD9DB',
      title: 'Failure:Invalid',
      category: 'Connector',
    },
  },

  // Form configuration
  formFields: [
    {
      key: 'branchType',
      label: 'Branch Type',
      type: 'select',
      defaultValue: 'business_hours',
      options: [{ label: 'Business Hours', value: 'business_hours' }],
      validation: {
        required: true,
      },
    },
    {
      key: 'businessHours',
      label: 'Business Hours Configuration',
      type: 'dateTime',
      defaultValue: {
        condition: 'is_within',
        timezone: 'Africa/Cairo',
        days: [
          { day: 'sunday', enabled: true, startTime: '09:00', endTime: '17:00' },
          { day: 'monday', enabled: true, startTime: '09:00', endTime: '17:00' },
          { day: 'tuesday', enabled: true, startTime: '09:00', endTime: '17:00' },
          { day: 'wednesday', enabled: true, startTime: '09:00', endTime: '17:00' },
          { day: 'thursday', enabled: true, startTime: '09:00', endTime: '17:00' },
          { day: 'friday', enabled: false },
          { day: 'saturday', enabled: false },
        ],
      },
      validation: {
        required: true,
        custom: (value: any) => {
          if (!value || !value.days) {
            return 'Business hours configuration is required';
          }

          const enabledDays = value.days.filter((day: any) => day.enabled);
          if (enabledDays.length === 0) {
            return 'At least one day must be enabled';
          }

          // Validate time ranges for enabled days
          for (const day of enabledDays) {
            if (day.startTime && day.endTime && day.startTime >= day.endTime) {
              return 'Starting time should be before closing time';
            }
          }

          return null;
        },
      },
    },
  ],
};

export default dateTime;
